<template>
  <div id="main">
    <h1>
      <transition
        mode="out-in"
        enter-active-class="animated fadeIn"
        leave-active-class="animated faster fadeOut"
      >
        <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
      </transition>Blagajna
    </h1>
    <data-table
      @row-click="handleRowClick"
      :columns="tableColumns"
      :tableData="tableData"
      :options="tableOptions"
      :slotTransactionsBalance="'balance'"
    ></data-table>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table.vue';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  components: {
    DataTable
  },
  computed: {
    /*
     * mapping vuex tableModule state
     * so we can pass it to table.vue component*/
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  created() {
    this.initTable('tableTreasuryCommunities');
  },
  destroyed() {},
  methods: {
    ...mapMutations(['setActiveCommunity']),
    ...mapActions('table', ['initTable']),
    back() {
      this.$router.back();
    },
    handleRowClick(e) {
      this.setActiveCommunity(e.row.id);

      this.$router.push({
        name: 'communityFinancesHome',
        params: {
          id: e.row.id
        }
      });
    }
  }
};
</script>

<style style = "scss">
#main {
  padding: 0px 10px;
  padding-top: 50px;
}
h1 {
  text-align: center;
  padding-bottom: 20px;
}
</style>
